export const UserData = [
  {
    id: 1,
    pillar: "pillar 1",
    performance: 10,
    userGain: 20,
  },
  {
    id: 2,
    pillar: "pillar 2",
    performance: 20,
    userGain: 45,
  },
  {
    id: 3,
    pillar: "pillar 3",
    performance: 30,
    userGain: 35,
  },
  {
    id: 4,
    pillar: "pillar 4",
    performance: 40,
    userGain: 75,
  },
  {
    id: 5,
    pillar: "pillar 5",
    performance: 50,
    userGain: 80,
  },
  {
    id: 6,
    pillar: "pillar 6",
    performance: 60,
    userGain: 85,
  },
  {
    id: 7,
    pillar: "pillar 7",
    performance: 70,
    userGain: 90,
  },
  {
    id: 8,
    pillar: "pillar 8",
    performance: 80,
    userGain: 90,
  },
  {
    id: 9,
    performance: 90,
  },
  {
    id: 10,
    performance: 100,
  },
];

export const PieData = [
  {
    id: 1,
    pillar: "",
    performance: 10,
    userGain: 4000,
  },
];

export const PieData1 = [
  {
    id: 1,
    pillar: "",
    performance: 10,
    userGain: 1000,
  },
];
export const PieData2 = [
  {
    id: 1,
    pillar: "",
    performance: 10,
    userGain: 1000,
  },
];
export const RadarData = [
  {
    id: 1,
    label: "Cognitive Skills",
    performance: 10,
    userGain: 25,
  },
  {
    id: 2,
    label: "Creativity & Imagination Skills",
    performance: 20,
    userGain: 50,
  },
  {
    id: 3,
    label: "Language & Communication Skills",
    performance: 30,
    userGain: 75,
  },
  {
    id: 4,
    label: "Physical Skills",
    performance: 40,
    userGain: 100,
  },
  {
    id: 5,
    label: "Socio-emotional Skills",
    performance: 50,
    userGain: 80,
  },
];
